<template lang='pug'>
div(:class='[$style[`cc-switcher`], $style[`cc-switcher-size-${sizeType}`]]')
  div(:class='[$style[`cc-switcher-btn`], $style[btnActive ? `cc-switcher-on` : `cc-switcher-off`]]' @click='changeValue')
    span {{ btnActive ? activeText : closeText }}


</template>

<script>
export default {
  // components: {},

  props: {
    activeText: {
      type: String,
      default: '開',
    },
    closeText: {
      type: String,
      default: '關',
    },
    sizeType: {
      type: String,
      default: 'normal',
    },
  },

  data() {
    return {
      btnActive: false,
    };
  },

  methods: {
    changeValue() {
      this.btnActive = !this.btnActive;
      this.$emit('sendSwitchStatus', this.btnActive);
    },
  },
};

</script>

<style module lang='scss'>
  @import '../../../sass/component/page/common/switcher.scss';
</style>
